
import { baseClasses } from '@weatherbug/common';

const breakingNewsStoriesUri = '/api/media/stories';
const breakingNewsCategory = 'breakingnews-global';
const breakingNewsStoriesCacheKey = 'breakingNewsStories';

const { PulseBaseProvider } = baseClasses;

const getNewsBreakingNewsStoriesValidationFunction = (result: any) => {
    return Array.isArray(result);
};

// Cache for 30 mins
const cacheDurationMilliseconds = 30 * 60 * 1000;

export class BreakingNewsProvider extends PulseBaseProvider {
    constructor(baseUrl?: string, authId?: string, secret?:string, options?: any, logger?: any) {
        super(baseUrl, authId, secret, options, logger);
        window.storage.sync[breakingNewsStoriesCacheKey] = this.getBreakingNewsSyncer.bind(this);
    }

    async getBreakingNewsSyncer(params: any) {
        const { syncParams, resolve, reject, id } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
            category: parsedQParams.category,
            count: parsedQParams.count
        };
        return await super.syncData(key, id, queryParams, breakingNewsStoriesUri, resolve, reject, getNewsBreakingNewsStoriesValidationFunction, pulseApi, undefined, undefined, false, cacheDurationMilliseconds);
    }

    async getBreakingNewsStories(category = breakingNewsCategory, count = 10) {
        const syncParams = {
            category,
            count
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(breakingNewsStoriesCacheKey, id, syncParams);
    }
}